import type { PolicyCallToAction } from '../types';

export const POLICY_MANAGE_TASK_ID = 8101;

export const GOVERNANCE_BASE_PATH = '/governance';
export const POLICIES_BASE_PATH = '/governance/politicas';
export const POLICY_SETTINGS_PATH = '/governance/configuracoes';
export const POLICY_RATINGS_PATH = `${POLICY_SETTINGS_PATH}/ratings`;
export const POLICY_COMPANIES_PATH = `${POLICY_SETTINGS_PATH}/empresas`;
export const POLICY_LIQUIDITY_PATH = `${POLICY_SETTINGS_PATH}/liquidez`;
export const LEGACY_POLICIES_PATH = 'policies';

export const FRESHNESS_WINDOW_DAYS = 3;
export const MIN_COVERAGE = 0.9;

export const HIDE_COMPLIANCE_HINTS = true;
export const RATINGS_READ_ONLY = true;

export const callToActionPath = (callToAction?: PolicyCallToAction | null): string =>
  (callToAction === 'CLASSIFY_COMPANY' || callToAction === 'CONFIGURE_RESERVE'
    ? POLICY_COMPANIES_PATH
    : POLICY_RATINGS_PATH);
